<template>
  <v-container fluid class="bill-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Bill</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Items</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Bill</p>
                        <v-select
                          class="mb-4"
                          :items=billtype
                          v-model="new_bill.billtype"
                          v-bind:error="errorindex == 0"
                          v-on:change="clearFields(); clearTransactions()"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the bill type">
                        </v-select>
                        <v-menu
                          ref="menu_billdate"
                          v-model="menu_billdate"
                          :close-on-content-click="false"
                          :return-value.sync="new_bill.billdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="mb-4"
                              outlined
                              dense
                              v-model="new_bill.billdate"
                              label="Bill Date"
                              v-bind="attrs"
                              v-bind:value="new_bill.billdate"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                              single-line hint="Please choose the bill date"
                              persistent-hint
                              >
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="new_bill.billdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_billdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_billdate.save(new_bill.billdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-menu
                          ref="menu_billduedate"
                          v-model="menu_billduedate"
                          :close-on-content-click="false"
                          :return-value.sync="new_bill.billduedate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="mb-4"
                              outlined
                              dense
                              v-model="new_bill.billduedate"
                              label="Bill Due Date"
                              v-bind="attrs"
                              v-bind:value="new_bill.billduedate"
                              v-on="on"
                              single-line hint="Please choose the bill due date"
                              persistent-hint
                              >
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="new_bill.billduedate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_billduedate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_billduedate.save(new_bill.billduedate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-select
                          class="mb-4"
                          :items="locations.map(x => { return {text: x.locationname, value: x._id} })"
                          v-model="new_bill.locationid"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Location"
                          persistent-hint
                          single-line hint="Please choose the location">
                        </v-select>
                        <v-select
                          v-if="type=='rental'"
                          class="mb-4"
                          :items="[
                            ...properties.map(x => { return {text: x.propertyname, value: x._id} })
                          ]"
                          v-model="new_bill.propertyid"
                          outlined
                          dense
                          placeholder="Property"
                          persistent-hint
                          single-line hint="Please choose the property">
                        </v-select>
                      </v-form>
                    </v-col>
                    <v-col v-if="new_bill.billtype=='Expense Bill'" cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-text-field
                          class="mb-4"
                          placeholder="Vendor Name"
                          single-line hint="Select the Vendor"
                          outlined
                          dense
                          readonly
                          append-icon="mdi-magnify"
                          @click:append="searchVendorDialog"
                          persistent-hint
                          v-model="new_bill.billname"
                          v-bind:error="errorindex == 3"
                        >
                        </v-text-field>      
                        <v-textarea
                          v-model="new_bill.billaddress"
                          v-bind:error="errorindex == 4"
                          outlined
                          rows=2
                          label="Address"
                          hint="please enter the vendor address"
                        ></v-textarea>
                        <v-text-field
                          class="mb-4"
                          v-model="new_bill.billphone"
                          v-bind:error="errorindex == 5"
                          outlined
                          dense
                          placeholder="Phone"
                          persistent-hint
                          single-line hint="Enter the phone">
                        </v-text-field>
                      </v-form>
                    </v-col>
                    <v-col v-if="new_bill.billtype=='Expense Bill'" cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          v-if="type=='service'"
                          class="mb-4"
                          :items="[
                            {text: 'None', value: null},
                            ...departments.map(x => { return {text: x.departmentname, value: x._id} }),
                          ]"
                          v-model="new_bill.departmentid"
                          v-bind:error="errorindex == 7"
                          outlined
                          dense
                          placeholder="Department"
                          persistent-hint
                          single-line hint="Please choose the deparment">
                        </v-select>
                        <v-select
                          v-if="type=='service'"
                          class="mb-4"
                          :items="[
                            {text: 'None', value: null},
                            ...saleschannels.map(x => { return {text: x.channelname, value: x._id} }),
                          ]"
                          v-model="new_bill.channelid"
                          v-bind:error="errorindex == 8"
                          outlined
                          dense
                          placeholder="Channel"
                          persistent-hint
                          single-line hint="Please choose the channel">
                        </v-select>
                        <v-select
                          v-if="type=='rental'"
                          class="mb-4"
                          :items="[
                            {text: 'None', value: null},
                            ...regions.map(x => { return {text: x.regionname, value: x._id} }),
                          ]"
                          v-model="new_bill.regionid"
                          v-bind:error="errorindex == 10"
                          outlined
                          dense
                          placeholder="Region"
                          persistent-hint
                          single-line hint="Please choose the region">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items=billpayterms
                          v-model="new_bill.billpayterms"
                          v-bind:error="errorindex == 11"
                          outlined
                          dense
                          placeholder="Pay Terms"
                          persistent-hint
                          single-line hint="Please choose the pay terms">
                        </v-select>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-text-field
                          class="mb-4"
                          v-model="new_bill.refnum"
                          outlined
                          dense
                          placeholder="Ref Num"
                          persistent-hint
                          single-line hint="Enter invoice or ref num">
                        </v-text-field>
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-select
                              class="mb-4"
                              :items="['USD', 'SGD', 'MMK', 'THB', 'KHR']"
                              v-model="new_bill.primaryCurrency"
                              v-bind:error="errorindex == 21"
                              outlined
                              dense
                              placeholder="Currency 1"
                              persistent-hint
                              single-line hint="Currency 1">
                            </v-select>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-select
                              class="mb-4"
                              :items="['USD', 'SGD', 'MMK', 'THB', 'KHR']"
                              v-model="new_bill.secondaryCurrency"
                              v-bind:error="errorindex == 22"
                              v-bind:value="primaryCurrency"
                              outlined
                              dense
                              placeholder="Currency 2"
                              persistent-hint
                              single-line hint="Currency 2">
                            </v-select>
                          </v-col>
                        </v-row>
                        <v-text-field
                          class="mb-4"
                          v-model="new_bill.currencyRate"
                          v-bind:error="errorindex == 23"
                          :v-bind:value="1"
                          outlined
                          dense
                          placeholder="Rate"
                          persistent-hint
                          single-line hint="Enter the currency rate">
                        </v-text-field>
                        <v-textarea
                          v-model="new_bill.billnote"
                          outlined
                          dense
                          rows=1
                          label="Note"
                          hint="please enter the note"
                        ></v-textarea>
                      </v-form>
                    </v-col>                                        
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/bill/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkBill">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card>
                  <v-row>
                    <v-col md="10">
                      <p class="text-h5">Items</p>
                    </v-col>
                    <v-col md="2" align="right">
                      <v-btn
                        class="button-shadow"
                        color="success"
                        @click="isAddTransaction=true">
                        Add
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                      <v-col cols="12" sm="12" md="12" lg="12">
                        <v-data-table
                          :headers="header_item"
                          :items="transactions"
                          :items-per-page="500"
                          :footer-props="footer"
                          class="elevation-0"
                        >
                          <template v-slot:item.accountid="{ item }">
                            {{ accounts.length>0 ? accounts.find(account=>account._id == item.accountid)['accountname'] : '' }}
                          </template>
                          <template v-slot:item.transdate="{ item }">
                            {{ item.transdate!=null ? new Date(item.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '' }}
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <v-btn icon color="primary" @click="editTransactionDialog(item)">
                              <v-icon>mdi-pencil-outline</v-icon>
                            </v-btn>
                            <v-btn icon color="primary" @click="deleteTransaction(item)">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                          outlined
                          color="primary"
                          @click="step = 1"
                        >
                          Back
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          v-if="1==0"
                          class="button-shadow"
                          color="primary"
                          @click="step = 3">
                          Next
                        </v-btn>
                        <v-btn
                          v-else
                          :loading="isReceiving"
                          class="button-shadow"
                          color="primary"
                          @click="insertBill()">
                          Save
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-dialog
        v-model="isSearchVendor"
        persistent
        scrollable
        width="1000px"
        max-width="1000px"
      >
        <v-card>
          <v-card-title>
            <v-container>
              <v-row>
                <span class="text-h5" style="padding:10px">Search Vendor</span>
              </v-row>

            <v-row>
              <v-col cols="12" md="4">
                <v-form>
                  <v-text-field
                    class="mb-4"
                    v-model="searchvendor.searchtext"
                    outlined
                    dense
                    append-icon="mdi-magnify"
                    @click:append="searchVendor"
                    v-on:keyup.enter="searchVendor"
                    placeholder="Search"
                    persistent-hint
                    single-line hint="Search vendor"
                  >
                  </v-text-field>
                </v-form>
              </v-col>
            </v-row>
            </v-container>

          </v-card-title>
          <v-card-text style="height: 400px;">
            <v-container>
              <v-row>

                <v-col cols="12" md="12">
                  <v-data-table
                    :items-per-page="100"
                    :headers="header_vendor"
                    :items="searches"
                    item-value="name"
                  >
                  <template v-slot:item.vendorimage="{ item }">
                    <img v-if="item.vendorimage" v-bind:src="item.vendorimage" alt="" width="80">
                  </template>
                  <template v-slot:item.vendorname="{ item }">
                    <a class="primaryConst--text">{{ item.vendorname }}</a>
                    <p>{{ item.vendortype }}</p>
                  </template>
                  <template v-slot:item.vendoraddress="{ item }">
                    <a class="primaryConst--text">{{ item.vendoraddress }}</a>
                    <p class="two-line">{{ item.vendorphone  }}</p>
                    <p class="two-line">{{ item.vendormobile  }}</p>
                  </template>
                  <template v-slot:item.countryid="{ item }">
                    <p class="two-line">{{ item.countryid!=undefined && countries.find(country=>country._id == item.countryid)!=null ? countries.find(country=>country._id == item.countryid)['countryname'] : ''   }}</p>
                  </template>
                  <template v-slot:item.vendorstatus="{ item }">
                    <v-chip
                      :color="!item.vendorstatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                      small>
                      {{ item.vendorstatus }}
                    </v-chip>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <div v-if="item._id!=undefined">
                    <v-btn icon color="primary" @click="selectVendor(item)">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                    </div>
                  </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isSearchVendor = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isAddTransaction"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    class="mb-4"
                    :items=data_subclasses
                    v-model="accountsubclass"
                    outlined
                    dense
                    placeholder="Subclass"
                    persistent-hint
                    single-line hint="Please choose the subclass">
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    class="mb-4"
                    :items="accounts.filter(account=>account.accountsubclass==accountsubclass && account.accountsubtype=='Account').map(x => {
                        return {text: x.accountname, value: x._id};
                    })"
                    v-model="new_transaction.accountid"
                    v-bind:error="errorindex == 11"
                    outlined
                    dense
                    placeholder="Account"
                    persistent-hint
                    single-line hint="Account">
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="new_transaction.itemdesc"
                    v-bind:error="errorindex == 12"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Desc"
                    persistent-hint
                    single-line hint="Description">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    type="number"
                    v-model="new_transaction.itemamount"
                    v-bind:error="errorindex == 13"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Amt"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
                <v-col v-if="new_bill.billtype=='Month Expense Bill'" cols="12" md="6">
                  <v-menu
                    ref="menu_transdate"
                    v-model="menu_transdate"
                    :close-on-content-click="false"
                    :return-value.sync="new_transaction.transdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        dense
                        v-model="new_transaction.transdate"
                        label="Transaction Date"
                        v-bind="attrs"
                        v-bind:value="new_transaction.transdate"
                        v-bind:error="errorindex == 1"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please choose the transaction date">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="new_transaction.transdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_transdate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_transdate.save(new_transaction.transdate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddTransaction=false; add_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="addTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isEditTransaction"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    class="mb-4"
                    :items=data_subclasses
                    v-model="accountsubclass2"
                    outlined
                    dense
                    placeholder="Subclass"
                    persistent-hint
                    single-line hint="Please choose the subclass">
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    class="mb-4"
                    :items="accounts.filter(account=>account.accountsubclass==accountsubclass2 && account.accountsubtype=='Account').map(x => {
                        return {text: x.accountname, value: x._id};
                    })"
                    v-model="edit_transaction.accountid"
                    outlined
                    dense
                    placeholder="Account"
                    persistent-hint
                    single-line hint="Account">
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="edit_transaction.itemdesc"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Desc"
                    persistent-hint
                    single-line hint="Description">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.itemamount"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Amt"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
                <v-col v-if="new_bill.billtype=='Month Expense Bill'" cols="12" md="6">
                  <v-menu
                    ref="menu_transdate_edit"
                    v-model="menu_transdate_edit"
                    :close-on-content-click="false"
                    :return-value.sync="edit_transaction.transdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        dense
                        v-model="edit_transaction.transdate"
                        label="Transaction Date"
                        v-bind="attrs"
                        v-bind:value="edit_transaction.transdate"
                        v-bind:error="errorindex == 1"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please choose the transaction date">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="edit_transaction.transdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_transdate_edit = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_transdate_edit.save(edit_transaction.transdate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditTransaction=false; edit_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="editTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import { sortDataAsc } from '../../../util/tools';
import router from '@/Routes';

export default {
  data () {
    return {
      header_item: [
        { text: 'Date', value: 'transdate', width: '8%'},
        { text: 'Account', value: 'accountid', width: '30%'},
        { text: 'Description', value: 'itemdesc'},
        { text: 'Amount', value: 'itemamount', width: '10%'},
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      header_vendor: [
        { text: 'Image', value: 'vendorimage', sortable: false },
        { text: 'Name', value: 'vendorname' },
        { text: 'Address', value: 'vendoraddress' },
        { text: 'Location', value: 'townshipid' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      
      accountsubclass: null,
      accountsubclass2: null,
      isSearchVendor: false,
      step: 1,
      new_bill: {},
      new_transaction: {},
      edit_transaction: {},
      transactions: [],
      searches: [],

      searchvendor: {},
      type: null,
      isRental: false,
      isAddTransaction: false,
      isEditTransaction: false,
      menu_billdate: false,
      menu_billduedate: false,
      menu_transdate: false,
      menu_transdate_edit: false,
      billtype: ['Expense Bill', 'Month Expense Bill'],
      billpayterms: ['Due on Receipt', 'Credit 5 Days', 'Credit 15 Days', 'Credit 30 Days'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
      isDualCurrency: false,
      primaryCurrency: null,
      secondaryCurrency: null,
      currencyRate: null,
      isTaxable: false,
      taxRate: null,
    }
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('Bill', ['bills', 'isReceiving']),
    ...mapState('Country', ['countries']),
    ...mapState('Department', ['departments']),
    ...mapState('Location', ['locations']),
    ...mapState('SalesChannel', ['saleschannels']),
    ...mapState('SystemSetting', ['settings']),
    ...mapState('Property', ['properties']),
    ...mapState('Region', ['regions']),
    ...mapState('User', ['users']),
    ...mapState('Vendor', ['vendors']),
    data_subclasses(){
      let filter = this.accounts.filter(account=>account.accountclass=='Expense');
      let object = Object.groupBy(filter, item => {
        return item.accountsubclass;
      });
      let result = Object.keys(object);
      return [...result, 'Loan Payable'];
    },
  },
  methods: {
    ...mapActions('Account', ['getAccountsRequest']),
    ...mapActions('Bill', ['getBillsRequest', 'insertBillRequest']),
    ...mapActions('Department', ['getDepartmentsRequest']),
    ...mapActions('Location', ['getLocationsRequest']),
    ...mapActions('SalesChannel', ['getSalesChannelsRequest']),
    ...mapActions('Search', ['searchVendorRequest']),
    ...mapActions('SystemSetting', ["getSetting"]),
    ...mapActions('Property', ['getPropertiesRequest']),
    ...mapActions('Region', ['getRegionsRequest']),
    ...mapActions('User', ['getUsersRequest']),
    ...mapActions('Vendor', ['getVendorsRequest']),
    checkBill(){
      if(!this.new_bill.billtype){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.new_bill.billdate){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.new_bill.locationid){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(this.new_bill.billtype=='Month Expense Bill'){
        this.new_bill.vendorid == null;
        this.new_bill.billaddress = null;
        this.new_bill.billphone = null;
        this.new_bill.billmobile = null;
        this.new_bill.departmentid = null;
        this.new_bill.channelid = null;
        this.new_bill.propertyid = null;
        this.new_bill.regionid = null;
        this.new_bill.billpayterms = null;
        this.errorindex = -1;
        this.step = 2;
        return true;
      }
      if(!this.new_bill.vendorid){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      if(!this.new_bill.billaddress){
        this.haserrors = true;
        this.errorindex = 4;
        return false;
      }
      if(!this.new_bill.billphone){
        this.haserrors = true;
        this.errorindex = 5;
        return false;
      }

      if(this.type=='service' && !this.new_bill.departmentid){
        this.haserrors = true;
        this.errorindex = 7;
        return false;
      }
      if(this.type=='service' && !this.new_bill.channelid){
        this.haserrors = true;
        this.errorindex = 8;
        return false;
      }
      if(this.type=='rental' && !this.new_bill.propertyid){
        this.haserrors = true;
        this.errorindex = 9;
        return false;
      }
      if(this.type=='rental' && !this.new_bill.regionid){
        this.haserrors = true;
        this.errorindex = 10;
        return false;
      }
      if(!this.new_bill.billpayterms){
        this.haserrors = true;
        this.errorindex = 11;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    checkTransaction(){
      if(!this.new_transaction.accountid){
        this.haserrors = true;
        this.errorindex = 11;
        return false;
      }
      if(!this.new_transaction.itemdesc){
        this.haserrors = true;
        this.errorindex = 12;
        return false;
      }
      if(!this.new_transaction.itemamount){
        this.haserrors = true;
        this.errorindex = 13;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    addTransaction(){
      if(!this.checkTransaction()) return;
      let trans = Object.assign({}, this.new_transaction, {id: Math.floor(Math.random() * Math.pow(10, 10))});
      this.transactions.push(trans);
      this.isAddTransaction = false;
      this.clearFields();
    },
    clearFields(){
      this.new_transaction = {};
    },
    clearTransactions(){
      this.transactions = [];
    },
    async insertBill() {
      if(this.transactions==null || this.transactions.length==0) return;
      let payload = {bill: this.new_bill, transactions: this.transactions};
      await this.insertBillRequest(payload);
      router.push('/bill/list');
    },
    deleteTransaction(item){
      let index = this.transactions.findIndex((trans) => trans.id == item.id);      
      if(index!=-1) this.transactions.splice(index,1);
    },
    insertTransaction(){
      let trans = Object.assign({}, this.transactions_expense, {id: Math.floor(Math.random() * Math.pow(10, 10)),});
      this.transactions.push(trans);
    },
    editTransactionDialog(item){
      let account = this.accounts.find(account=>account._id == item.accountid);
      this.accountsubclass2 = account.accountsubclass;
      this.edit_transaction = Object.assign({}, item);
      this.isEditTransaction = true;
    },
    editTransaction(){
      this.isEditTransaction = false;
      let index = this.transactions.findIndex((trans) => trans.id == this.edit_transaction.id);
      let trans = Object.assign({}, this.edit_transaction);
      this.transactions.splice(index, 1, trans);
      this.edit_transaction = {};
    },
    searchVendorDialog(){
      this.searchvendor = {};
      this.isSearchVendor = true;
    },
    selectVendor(item){
      this.new_bill.billname = item.vendorname;
      this.new_bill.billaddress = item.vendoraddress;
      this.new_bill.billphone = item.vendorphone;
      this.new_bill.billmobile = item.vendormobile;
      this.new_bill.vendorid = item._id;
      this.isSearchVendor = false;
    },
    async searchVendor(){
      let results = await this.searchVendorRequest(this.searchvendor);
      this.searches = results;
    }
  },

  async created () {
    let params = this.$route.params;
    if(params!=null){
      this.new_bill = Object.assign({}, params);
      delete this.new_bill['_id'];
      delete this.new_bill['billdate'];
      delete this.new_bill['billduedate'];
      delete this.new_bill['billstatus'];
      this.transactions = Object.assign([], params.transactions);
      for(var item of this.transactions){
        item['id'] = item['_id'];
        delete item['_id'];
        delete item['transdate'];
      }
    }

    if(this.accounts.length==0) await this.getAccountsRequest();
    if(this.departments.length==0) await this.getDepartmentsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.saleschannels.length==0) await this.getSalesChannelsRequest();
    if(this.users.length==0) await this.getUsersRequest();
    if(this.properties.length==0) await this.getPropertiesRequest();
    if(this.regions.length==0) await this.getRegionsRequest();
    if(this.vendors.length==0) await this.getVendorsRequest();
    sortDataAsc(this.departments, 'departmentname');

    let currency = await this.getSetting({code: 'CurrencySettings', name: 'PrimaryCurrency'}, );
    let isTaxable = await this.getSetting({code: 'TaxSettings', name: 'isTaxEnabled'}, );
    this.new_bill = Object.assign(this.new_bill, {primaryCurrency: currency, secondaryCurrency: currency, currencyRate: 1, isTaxable: isTaxable});

    this.isRental = await this.getSetting({code: 'CompanySettings', name: 'isRental'}, );
    this.isRental==true ? this.type='rental' : this.type='service';
  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
